var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 20,
    viewBox: "0 0 1 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5C0 0.223857 0.223858 0 0.5 0C0.776142 0 1 0.223858 1 0.5V19.5C1 19.7761 0.776142 20 0.5 20C0.223858 20 0 19.7761 0 19.5V0.5Z",
    fill: "#3B304F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDivider);
export default __webpack_public_path__ + "static/media/nav-divider.45c5b8ecb4f45ec2117816a9d9eb6795.svg";
export { ForwardRef as ReactComponent };